<template>
  <ButtonTooltip
    :tooltip-text="hint"
    icon
    color="primary"
    x-small
    target="_blank"
    :href="targetLink"
    @click.stop
  >
    <v-img v-if="isImageIcon" v-bind="imageIconProps" />
    <ESvgIcon
      v-else-if="svgIcon"
      :color="$vuetify.theme.themes.light.primary"
      :icon="svgIcon"
      v-bind="iconProps"
    />
    <v-icon v-else small v-bind="iconProps"> {{ icon }} </v-icon>
  </ButtonTooltip>
</template>

<script>
import ButtonTooltip from "@evercam/shared/components/ButtonTooltip.vue"
export default {
  name: "OpenInNewWindowButton",
  components: { ButtonTooltip },
  props: {
    hint: {
      type: String,
      default: "Open Account In New Window",
    },
    targetLink: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: "fa-external-link-alt",
    },
    svgIcon: {
      type: String,
      default: "",
    },
    imageIconProps: {
      type: Object,
      default: () => {},
    },
    iconProps: {
      type: Object,
      default: () => ({}),
    },
    btnContainerClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    isImageIcon() {
      return !!this.imageIconProps?.src
    },
  },
}
</script>
